import { render, staticRenderFns } from "./PlayersStats.vue?vue&type=template&id=7460cc24&scoped=true&"
import script from "./PlayersStats.vue?vue&type=script&lang=js&"
export * from "./PlayersStats.vue?vue&type=script&lang=js&"
import style0 from "./PlayersStats.vue?vue&type=style&index=0&id=7460cc24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7460cc24",
  null
  
)

export default component.exports